import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SeaticsMapWidget from '../components/features/SeaticsMapWidget';
import { getEventsById } from '../reducers/events/byId';
import { getLocationQuery } from '../reducers/location';

class TaraSeaticsMapWidgetContainer extends React.PureComponent {
  static propTypes = {
    eventId: PropTypes.string.isRequired,
    currentEvent: PropTypes.object.isRequired,
  };

  static defaultProps = {
  };

  state = {
    isReady: true,
    ticketList: [],
  };

  recommendedTicketList = [];

  componentWillReceiveProps(nextProps) {
    if (nextProps.eventId !== this.props.eventId) {
      this.setState({ isReady: false });
      setTimeout(() => {
        this.setState({ isReady: true });
      }, 200);
    }

    const { currentEvent, shouldShowAllTickets } = nextProps;
    const { recommendedList, ticketList } = currentEvent;

    const isChangingShowAllTickers = shouldShowAllTickets !== this.props.shouldShowAllTickets;
    const isChangingTicketList = ticketList !== this.props.currentEvent.ticketList;

    if (isChangingShowAllTickers || isChangingTicketList) {
      if (shouldShowAllTickets) {
        this.setTicketList(currentEvent.ticketList);
      } else {
        this.setTicketList(this.recommendedTicketList);
      }
    }

    if (recommendedList && Object.keys(recommendedList).length) {
      const recommendedChanged = recommendedList !== this.props.currentEvent.recommendedList;

      if (recommendedChanged) {
        this.recommendedTicketList = Object.keys(currentEvent.recommendedList).map(key => currentEvent.recommendedList[key]);
        this.setTicketList(this.recommendedTicketList);
      }
    }
  }

  setTicketList = ticketList => this.setState({ ticketList });

  render() {
    const {
      currentEvent
    } = this.props;

    return this.state.isReady && (
      <SeaticsMapWidget
        {...currentEvent}
        {...this.props}
        hasTaraFilters
        hasTicketAttributes={!this.props.shouldShowAllTickets}
        shouldShowAllTickets={this.props.shouldShowAllTickets}
        ticketList={this.state.ticketList}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  currentEvent: getEventsById(state)[ownProps.eventId] || {},
  locationQuery: getLocationQuery(state),
  ...ownProps,
});

export default connect(mapStateToProps)(TaraSeaticsMapWidgetContainer);



// WEBPACK FOOTER //
// ./src/containers/TaraSeaticsMapWidgetContainer.js